import messages from './messages';
import { regexMap, EMAIL_MAX_LENGTH } from './constants';

export const rules = {
    email: function (user) {
        const email = (user.email || '').trim();
        return [
            {
                isValid: regexMap.email.test(email),
                message: messages.invalidEmail,
            },
            {
                isValid: email.length <= EMAIL_MAX_LENGTH,
                message: messages.emailMax,
            },
        ];
    },
    password: function (user) {
        const password = (user.password || '').trim();
        return [
            {
                isValid: regexMap.min.test(password),
                message: messages.passwordMin,
            },
            {
                isValid: regexMap.max.test(password),
                message: messages.passwordMax,
            },
        ];
    },
};
